import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';

@Component({
  selector: 'app-company-pins',
  templateUrl: './company-pins.component.html',
  styleUrl: './company-pins.component.css'
})
export class CompanyPinsComponent implements OnInit {

  currentUser: any;
  loading: boolean = false;
  pinList: any[] = [];
  filteredPinList: any[] = [];
  showModal: boolean = false;
  history: any[] = [];
  addressSearch = '';
  selectedRep: string | null = null;
  dispositionSearch = '';
  dateRange: Date[] | null = null;
  radioValue = 'active';

  constructor(
    private data: DataserviceService
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    this.getData();
  }

  get repOptions(): string[] {
    const labels = (this.pinList || []).map(p =>
      p.first_name && p.last_name ? `${p.first_name} ${p.last_name}` : 'Unassigned'
    );
    return [...new Set(labels)].sort((a, b) => a.localeCompare(b));
  }

  getData() {
    this.loading = true;
    this.data.get('pins/by-company/' + this.currentUser.company_id, {}).subscribe({
      next: (res: any) => {
        this.pinList = res.data || [];
        this.applyFilters();
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      }
    });
  }

  onTabChange(index: number) {
    this.radioValue = index === 0 ? 'active' : 'inactive';
    this.applyFilters();
  }

  applyFilters() {
    let list = this.pinList || [];
    const search = (this.addressSearch || '').trim().toLowerCase();
    const dispoSearch = (this.dispositionSearch || '').trim().toLowerCase();

    // Not used at the moment, but keeping for future use
    if (this.radioValue === 'active') {
        list = list.filter(p => p.status === 'current' || p.status === 'previous');
      // } else {
      //   list = list.filter(p => p.status === 'previous');
      }
    if (search) {
      list = list.filter(p => {
        const addr = [p.address_line_1, p.address_zip, p.address_city].filter(Boolean).join(' ').toLowerCase();
        return addr.includes(search);
      });
    }
    if (this.selectedRep != null && this.selectedRep !== '') {
      list = list.filter(p => {
        const label = p.first_name && p.last_name ? `${p.first_name} ${p.last_name}` : 'Unassigned';
        return label === this.selectedRep;
      });
    }
      if (dispoSearch) {
      list = list.filter(d => {
        const addr = [d.disposition].filter(Boolean).join(' ').toLowerCase();
        return addr.includes(dispoSearch);
      });
    }
    if (this.dateRange && this.dateRange.length === 2) {
      const startStr = this.toDateKey(this.dateRange[0]);
      const endStr = this.toDateKey(this.dateRange[1]);
      list = list.filter(p => {
        const key = this.toDateKey(p.date);
        return key !== null && startStr !== null && endStr !== null && key >= startStr && key <= endStr;
      });
    }
    this.filteredPinList = list;
  }

  clearFilters() {
    this.addressSearch = '';
    this.selectedRep = null;
    this.dateRange = null;
    this.applyFilters();
  }

  onDateRangeChange(range: Date[] | null) {
    this.dateRange = Array.isArray(range) && range.length === 2 ? range : null;
    this.applyFilters();
  }

  private toDateKey(value: any): string | null {
    if (!value) return null;
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
      return value.trim();
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return null;
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getHistory(id: any) {
    this.loading = true;
    this.showModal = true;
    this.data.get('pins/pin-history/' + id, {}).subscribe({
      next: (res: any) => {
        this.history = res.data;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      }
    });
  }
}